<lib-modal-container class="bootstrap-wrapper" classModalTitle="bg-azul-sunedu" [modalTitle]="'Solicitud de key'"
  cancelText="Cerrar" [noActions]="true" (dismiss)="handleClose()">

  <div fxLayout="column" class="m-b-25">
    <div *ngIf="tokenSended" class="text-center">
      <label class="font-bold">Se envió a su correo electrónico la key de acceso.</label>
    </div>
    <div *ngIf="showError" class="text-center">
      <label class="font-bold">Ocurrió un problema, vuelva a intentarlo.</label>
    </div>
    <div *ngIf="!tokenSended && showError == null" class="text-center">
      <label class="font-bold">¿Requiere solicitar información?</label>
      <div class="m-t-10">
        <button class="p-l-0" mat-button (click)="handleClickCheckCiudadano()">
          <mat-icon *ngIf="!checkCiudadano">radio_button_unchecked</mat-icon>
          <mat-icon *ngIf="checkCiudadano" class="text-naranja-sunedu">
            radio_button_checked
          </mat-icon>
          Especialista
        </button>

        <button mat-button (click)="handleClickCheckCiudadano()">
          <mat-icon *ngIf="checkCiudadano">radio_button_unchecked</mat-icon>
          <mat-icon *ngIf="!checkCiudadano" class="text-naranja-sunedu">
            radio_button_checked
          </mat-icon>
          Organización
        </button>
      </div>
    </div>
    <div *ngIf="!tokenSended && showError == null" fxFlex="auto" class="text-left">
      <form fxFlex="auto" [formGroup]="form">
        <div *ngIf="!checkCiudadano" class="font-bold">Nombre de la organización</div>
        <lib-form-control *ngIf="!checkCiudadano" appearance="outline" variant="text" [formGroupParent]="form" label="Nombre de la organización"
          controlName="nombreOrganizacion" [inputProps]="{maxlength:80}">
        </lib-form-control>
        <div *ngIf="!checkCiudadano" class="font-bold">Cargo</div>
        <lib-form-control *ngIf="!checkCiudadano" appearance="outline" variant="text" [formGroupParent]="form" label="Cargo"
          controlName="cargo" [inputProps]="{maxlength:80}">
        </lib-form-control>
        <div *ngIf="checkCiudadano" class="font-bold">Tipo de documento</div>
        <lib-form-control *ngIf="checkCiudadano" appearance="outline" variant="select" bindLabel="label" bindValue="name"
          [formGroupParent]="form" placeholder="Seleccione" controlName="tipoDocumento" label="Tipo de documento"
          [options]="tiposDocumentos" (selectionChange)="handleChangeVariables()">
        </lib-form-control>
        <div *ngIf="checkCiudadano" class="font-bold">Número de documento</div>
        <lib-form-control *ngIf="checkCiudadano" appearance="outline" variant="text" [formGroupParent]="form" label="Número de documento"
          controlName="numeroDocumento" [inputProps]="form.value.tipoDocumento == 'Dni'? {maxlength:8} : {maxlength:18} ">
        </lib-form-control>
        <div class="font-bold">Nombre de especialista</div>
        <lib-form-control appearance="outline" variant="text" [formGroupParent]="form" label="Nombre de especialista"
          controlName="nombreInvestigador" [inputProps]="{maxlength:60}">
        </lib-form-control>
        <div class="font-bold">Apellido de especialista</div>
        <lib-form-control appearance="outline" variant="text" [formGroupParent]="form" label="Apellido de especialista"
          controlName="apellidoInvestigador" [inputProps]="{maxlength:60}">
        </lib-form-control>
        <div class="font-bold">Correo</div>
        <lib-form-control appearance="outline" variant="text" [formGroupParent]="form" label="Correo"
          controlName="correo" [inputProps]="{maxlength:60}">
        </lib-form-control>
        <div class="font-bold">Teléfono</div>
        <lib-form-control appearance="outline" variant="text" [formGroupParent]="form" label="Teléfono"
          controlName="telefono" [inputProps]="{maxlength:15}">
        </lib-form-control>
        <div class="font-bold">Indica el objetivo que pretendes alcanzar con la información en estudio y quiénes son los
          beneficiarios</div>
        <lib-form-control appearance="outline" variant="multiline" [formGroupParent]="form" label="Objetivo"
          controlName="objetivo" [inputProps]="{maxlength:500}">
        </lib-form-control>
        <ngx-recaptcha2 #captchaElem [siteKey]="siteKey" (success)="handleSuccess($event)" formControlName="recaptcha"></ngx-recaptcha2>
        <button class="p-l-0" mat-button (click)="handleClickCheckTerminos()">
          <mat-icon *ngIf="!checkTerminos">check_box_outline_blank</mat-icon>
          <mat-icon *ngIf="checkTerminos" class="text-naranja-sunedu">
            check_box
          </mat-icon>
        </button>
        Acepto 
        <a href="/assets/pdf/terminosycondiciones.pdf" mat-flat-button class="text-naranja-sunedu" target="_blank">
          términos y condiciones
        </a>
      </form>

    </div>
    <div *ngIf="!tokenSended && showError == null" class="text-center">
      <button (click)="handleEnviar()" [disabled]="loading" mat-flat-button [ngClass]="!loading ? 'bg-azul-sunedu rounded-full m-l-15':'bg-gray-sunedu rounded-full m-l-15'">
        Enviar
      </button>
    </div>
  </div>

</lib-modal-container>